import { motion } from 'framer-motion'
import { useDispatch } from 'react-redux'
import * as Yup from 'yup'
import { IBusinessInfo } from '../../../shared/types'
import { registrationSliceActions } from '../../../store/features/registration'
import TextInput from '../../organisms/TextInput'
import ValidatedForm from '../../organisms/ValidatedForm'
import { ValidatedPrimaryButton } from '../../organisms/ValidationButton'

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

const initialValues= {

    name: "",
    email: "",
    phone: "",
    address: ""

}

const validationSchema = Yup.object().shape({
    name: Yup.string().required().min(1).max(20).label("name"),
    address: Yup.string().required().min(5).max(100).label("address"),
    email: Yup.string().required().email().label("email"),
    phone: Yup.string().required().matches(phoneRegExp).label("phone"),
})

export default function BusinessInfo() {

    const dispatch = useDispatch()

    const submit = (businessInfo: IBusinessInfo)=>{

        dispatch(registrationSliceActions.setBusinessInfo(businessInfo))
        dispatch(registrationSliceActions.setCurrentPage(2))

    }

    return (
        <motion.div
            className="w-full h-92.5 md:mt-46 mt-32 sm:w-52"
            exit={{
                x: "-100px"
            }}
            initial={{
                opacity: 0,
                x: "100px"
            }}
            animate={{
                opacity: 1,
                x: 0
            }}
        >
            
            <div
                className="absolute top-1/2 left-1/2 translate-x-neg-1/2 translate-y-neg-1/2 bg-white py-8 px-12 shadow-2xl rounded"
            >
                <form>
                    <ValidatedForm
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={submit}
                    >
                        <div
                            className='sm:w-72 md:mt-44'
                        >
                            <header className='leading-7 text-center'>
                                <h2 className='font-semibold text-2xl'>Business Information</h2>
                                <span className="text-graphite" >Please tell us about your retail business</span>
                            </header>
                        </div>

                        <div
                            className="my-12 w-full"
                        >

                            <TextInput
                                name="name"
                                text="Business name"
                                placeholder="business name"
                                type="text"
                            />

                            <div
                                className="flex flex-row my-6 md:flex-col"
                            >
                                <div className="mr-1 last:m-0 md:mr-0 md:mb-4">
                                    <TextInput
                                        name="email"
                                        text="Business email"
                                        placeholder="email"
                                        type="email"
                                    />
                                </div>
                                <div className="mr-1 last:m-0">
                                    <TextInput
                                        name="phone"
                                        text="Business phone"
                                        placeholder="business number"
                                        type="phone"
                                    />
                                </div>
                            </div>

                            <TextInput
                                name="address"
                                text="Business address"
                                placeholder="business address"
                                type="text"
                            />

                        </div>
                        <ValidatedPrimaryButton
                            loading={false}
                        >
                            Proceed
                        </ValidatedPrimaryButton>
                    </ValidatedForm>
                </form>

            </div>

        </motion.div>
    )
}